const activity = {
  activity: "Hoạt động", // translated 
  activities: "Các hoạt động", // translated 
  dates: "ngày tháng", // translated 
  location: "Vị trí", // translated 
  languages: "Ngôn ngữ", // translated 
  categories: "Thể loại", // translated 
  ticketOption: "Tùy chọn vé", // translated 
  numberOfRatings: "Số lượng đánh giá", // translated 
  meetingPointInfo: "Thông tin điểm hẹn", // translated 
  meetingPoint: "Điểm hẹn", // translated 
  meetingPoints: "Điểm hẹn", // translated 
  providedBy: "Được cung cấp bởi", // translated 
  expirationDate: "Ngày hết hạn", // translated 
  groupSize: "Kích thước nhóm", // translated 
  features: "Đặc trưng", // translated 
  basedOn: "Dựa trên", // translated 
  reviewsFromVerCustomers: "đánh giá từ khách hàng đã được xác minh", // translated 
  excellent: "xuất sắc", // translated 
  great: "Tuyệt", // translated 
  average: "trung bình", // translated 
  poor: "nghèo", // translated 
  bad: "xấu", // translated 
  onlyBookedCustomersTooltip:
    "Chỉ những khách hàng đã đặt hoạt động này mới có thể để lại đánh giá.", // translated 
  noReviewsYet: "Hiện tại, chưa có đánh giá nào cho hoạt động này.", // translated 
  backToActivitiesList: "Quay lại danh sách hoạt động", // translated 
  getPrices: "nhận báo giá", // translated 
  availabilityAndPrices: "Tình trạng sẵn có và giá cả", // translated 
  ticketOptions: "Các lựa chọn vé", // translated 
  ticketInfo: "Thông tin vé", // translated 
  selectYourTickets: "Chọn vé của bạn", // translated 
  product: "Sản phẩm", // translated 
  total: "Tổng cộng", // translated 
  slot: "Chỗ", // translated 
  language: "Ngôn ngữ", // translated 
  tickets: "Vé", // translated 
  ticketsFor: "Vé cho", // translated 
  previousStep: "Bước trước đó", // translated 
  onlyAvailableInEnglish: "Chỉ có sẵn bằng tiếng Anh.", // translated 
  guest: "Khách mời", // translated 
  leadGuest: "Khách mời chính", // translated 
  adult: "Người lớn", // translated 
  child: "Đứa trẻ", // translated 
  pleaseSelectAdult: "Vui lòng chọn ít nhất một người lớn", // translated 
  notAvailableActivity: "Sản phẩm này hiện không có sẵn.", // translated 
  required: "Yêu cầu", // translated 
  pickupPoint: "Điểm đón", // translated 
  pickupPoints: "Điểm đón khách", // translated 
  ticketType: "Loại vé", // translated 
  anonymous: "Vô danh", // translated 
  printedVoucher: "Chấp nhận phiếu in.", // translated 
  mobileVoucher: "Chấp nhận phiếu giảm giá trên điện thoại di động", // translated 
  mixedVoucher: "Chấp nhận phiếu giảm giá trên điện thoại di động hoặc bản in.", // translated 
  safetyMeasures: "Các biện pháp an toàn đã được áp dụng.", // translated 
  doThisBecause: "Hãy làm điều này bởi vì", // translated 
  safetyInfo: "Thông tin an toàn", // translated 
  reviewsHighestFirst: "Số lượng đánh giá (cao nhất trước)", // translated 
  bookingFee: "Phí đặt chỗ", // translated 
  startDate: "Ngày bắt đầu", // translated 
  endDate: "Ngày kết thúc", // translated 
  cancellationDeadlineAndFees: "Hạn chót và phí hủy bỏ", // translated 
  resetTickets: "Đặt lại vé", // translated 
  instantConfirmation: "Xác nhận ngay lập tức", // translated 
  clickResetBtn: "Nhấp vào nút đặt lại để bắt đầu lại lựa chọn của bạn.", // translated 
  whatToRemember: "Những điều cần nhớ", // translated 
};


export default activity;
